// extracted by mini-css-extract-plugin
export default {"formHeader":"Form_formHeader__h7dJc","main_div":"Form_main_div__uQ0xv","main_form_div":"Form_main_form_div__CTYbR"};